import { defineReactiveShallow, observable } from "./common";
import { ShallowArray } from "./ShallowArray";
var prefix = "@@shallowReactive_";
/**
 *
 * @param keys 定义哪些key需要转化成响应式
 * @returns
 */
export function shallowReactive(keys) {
    if (keys === void 0) { keys = []; }
    return function (target, propertyKey) {
        var proxyKey = prefix + propertyKey;
        // 原型上的getter setter
        Object.defineProperty(target, propertyKey, {
            get: function () {
                if (process.env.NODE_ENV !== 'production') {
                    throw new Error("This property [".concat(propertyKey, "] must be initialized"));
                }
                return null;
            },
            set: function (value) {
                Object.defineProperty(this, propertyKey, {
                    set: function (value) {
                        //  = 操作时转换成 ShallowArray
                        var shallowValue = getShallowValue(value, {
                            hostKey: propertyKey,
                            keys: keys,
                            host: this
                        });
                        this[proxyKey] = shallowValue;
                    },
                    get: function () {
                        return this[proxyKey];
                    },
                    enumerable: true,
                    configurable: true
                });
                var shallowValue = getShallowValue(value, {
                    hostKey: propertyKey,
                    keys: keys,
                    host: this
                });
                // 把原数据放代理对象里面，这样实际访问才有操作空间把 newArray转换成 ShallowArray ，用于出来 state.list = []
                defineReactiveShallow(this, proxyKey, shallowValue);
                Object.defineProperty(this, proxyKey, { enumerable: false });
            },
            enumerable: false,
            configurable: true
        });
    };
}
function getShallowValue(value, options) {
    if (Array.isArray(value)) {
        var array = new ShallowArray(value, options);
        return array;
    }
    else if (typeof value === 'object' && value !== null) {
        observable(value, options.keys);
        return value;
    }
    else {
        return value;
    }
}
